import { render } from "./after-login.vue?vue&type=template&id=c782a936&scoped=true"
import script from "./after-login.vue?vue&type=script&lang=js"
export * from "./after-login.vue?vue&type=script&lang=js"

import "./after-login.vue?vue&type=style&index=0&id=c782a936&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c782a936"]])

export default __exports__